<template>
    <div>
        <div class="page-container">
            <div class="title">台账信息</div>
            <div class="search">
                <el-row :gutter="20">
                    <el-col style="width: 65px"><span class="search-desc">搜索</span></el-col>
                    <el-col :xs="24" :lg="4"><el-input size="medium" placeholder="请输入台账号或试剂名称" v-model="key"></el-input></el-col>
                    <el-button type="primary" size="medium" @click="handleSearch">搜索</el-button>
                    <el-button type="primary" size="medium" @click="handleExport">导出</el-button>
                    <el-button type="primary" size="medium" @click="handleExportDetail" v-if="school_id==5">导出含明细</el-button>
                </el-row>
            </div>
            <Form :dialogFormVisible="dialogFormVisible" @controlFormWindow="controlFormWindow" :storageNum="storageNum" />
            <Table
                ref="table"
                v-loading="LoadingTable"
                :headerData="headerData"
                :tableData="tableData"
                :tableText="tableText"
                :tableCount="tableCount"
                :border="true"
                @changeTable="changeTable"
            >
                <el-table-column fixed="right" label="操作" width="180" align="center">
                    <template slot-scope="scope">
                        <el-button type="text" size="small" @click="addParameter(scope.row)">增加</el-button>
                        <el-button @click="checkDetail(scope.row)" type="text" size="small">查看</el-button>
                        <el-button @click="printQr(scope.row)" type="text" size="small">打印二维码</el-button>
                    </template>
                </el-table-column>
            </Table>
        </div>
    </div>
</template>

<script>
    import Table from 'components/Table';
    import Form from './Form';
    import { parametertHeader } from './headerData.js';
    import parameterMessage from 'api/Message/parameterMessage.js';
    const _parameterMessage = new parameterMessage();
    export default {
        data() {
            return {
                school_id:localStorage.SCHOOL_ID,
                key: '',
                // per_page: 10,
                // page: 1,
                dialogFormVisible: false,
                storageNum: '',
                // 表单必须数据
                headerData: parametertHeader,
                tableData: [], // 表格数据
                tableText: '加载中',
                tableCount: 0,
                selectedStr: '', // 选择的表格选择字符串
                currentPage: 1, // 当前页
                currentPageLength: 10, // 当前页长度
                LoadingTable: false, //当前table的loading
            };
        },
        created() {
            this.getParameterlist();
        },
        mounted() {},
        methods: {
            getParameterlist() {
                // this.tableData = []
                this.tableText = '加载中';
                this.LoadingTable = true;
                _parameterMessage
                    .getParameterlist(this.currentPageLength, this.currentPage, this.key)
                    .then(res => {
                        // res.items.forEach(element => {
                        //     element.SHOW_CURRENT_VOLUME = element.CURRENT_VOLUME+' '+element.VALUMEUNIT_ID
                        // });
                        this.tableData = res.items;
                        this.tableCount = res._meta.totalCount;
                        if (res.items.length === 0) {
                            this.tableText = '暂无数据';
                        }
                    })
                    .catch(err => {
                        this.$message.error('请求错误');
                    })
                    .finally(_ => {
                        this.LoadingTable = false;
                    });
            },
            // 改变页数/页长度
            changeTable({ currentPage, pageLength }) {
                // this.tableData = []
                // 临时存储当前页/当前页长度
                this.currentPage = currentPage;
                this.currentPageLength = pageLength;
                // this.per_page = pageLength;
                this.getParameterlist();
            },
            // 增加弹窗
            addParameter(row) {
                if (row.CURRENT_VOLUME > 0) {
                    this.currentData = {};
                    this.dialogFormVisible = true;
                    this.storageNum = row.STORAGE_NO;
                } else {
                    this.$message({
                        message: '余量为0！不能增加',
                        type: 'warning',
                    });
                }
            },
            controlFormWindow(flag) {
                this.dialogFormVisible = flag;
                this.getParameterlist();
            },
            //到处台账
            handleExport(){
                window.open(localStorage.BASE_URL + 'chem-storage/export?key=' + this.key + '&Labtoken=' + localStorage.Labtoken);
            },
            //导出台账含使用记录
            handleExportDetail(){
                window.open(localStorage.BASE_URL + 'chem-storage/export-detail?key=' + this.key + '&Labtoken=' + localStorage.Labtoken);
            },
            // 查看
            checkDetail(row) {
                this.$router.push({ path: `/cs/parameterInformation/detail/${row.STORAGE_NO}` });
            },
            //  打印
            printQr(row) {
                window.open(localStorage.BASE_URL + 'chem-storage/printqr?storageno=' + row.STORAGE_NO + '&Labtoken=' + localStorage.Labtoken);
            },
            handleSearch() {
                this.$refs.table.handleCurrentChange(1);
            },
        },
        components: {
            Table,
            Form,
        },
    };
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
    .title {
      width 100%
      height 30px
      line-height 30px
      font-size:16px;
      font-family:SimSun;
      font-weight:bold;
      color:rgba(62,62,62,1)
      text-align center
    }
</style>
